export enum BillingAddressFormFields {
  COUNTRY = 'country',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  INSTITUTION = 'companyName',
  ADDRESS_ONE = 'address1',
  ADDRESS_TWO = 'address2',
  CITY = 'city',
  STATE = 'state',
  POSTAL_CODE = 'postalCode',
  PHONE_NO = 'phoneNumber',
  IS_DEFAULT = 'active',
}

export const BillingAddressFormInitialState = {
  [BillingAddressFormFields.COUNTRY]: '',
  [BillingAddressFormFields.FIRST_NAME]: '',
  [BillingAddressFormFields.LAST_NAME]: '',
  [BillingAddressFormFields.INSTITUTION]: '',
  [BillingAddressFormFields.ADDRESS_ONE]: '',
  [BillingAddressFormFields.ADDRESS_TWO]: '',
  [BillingAddressFormFields.CITY]: '',
  [BillingAddressFormFields.STATE]: '',
  [BillingAddressFormFields.POSTAL_CODE]: '',
  [BillingAddressFormFields.PHONE_NO]: '',
  [BillingAddressFormFields.IS_DEFAULT]: false,
};
